<template>
  <div class="container">
    <base-text
      name="title"
      label="Manage title:"
      v-model="page.title"
    />
    <ckeditor
      :editor="editor"
      v-model="page.content"
      :config="editorConfig"
    />
    <div class="row mt-3">
        <div class="col-6 text-left">
          <base-button radius="bl" component-class="blue" @click.native="$router.push({ name: 'user.pages' })">
            <i class="fas fa-arrow-left mr-3"></i> Back
          </base-button>
        </div>

      <div class="col-6 text-right">
        <button
          class="btn btn-success"
          @click="handlePageUpdate"
        >Update</button>
      </div>
    </div>
  </div>
</template>

<script>
  import { mapActions } from 'vuex';
  import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
  import CKEditor from '@ckeditor/ckeditor5-vue';
  import BaseText from '@/components/inputs/text/BaseText';
  import BaseButton from '@/components/inputs/button/BaseButton';

  export default {
    data() {
      return {
        editor: ClassicEditor,
        editorData: '',
        editorConfig: {},
      };
    },

    computed: {
      page() {
        return this.$store.state.app.staticPage;
      }
    },

    methods: {
      ...mapActions({
        getStaticPage: 'app/getStaticPage',
        updateStaticPage: 'app/updateStaticPage',
        updateStaticPages: 'app/getStaticPages',
      }),
      handlePageUpdate() {
        const updateData = {
          id: this.$route.params.pageId,
          title: this.page.title,
          content: this.page.content
        };
        this.updateStaticPage(updateData);
        this.updateStaticPages();
        this.$router.push({ name: 'user.pages' });
      }
    },

    mounted() {
      this.getStaticPage(this.$route.params.pageId);
    },

    components: {
      'ckeditor': CKEditor.component,
      'base-text': BaseText,
      'base-button': BaseButton,
    }
  };
</script>
